import { motion } from "framer-motion";
import { styled } from "prism-react";
import { forwardRef } from "react";

import { useTitleState } from "./useTitleState";

const StyledMotionDiv = styled(motion.div);

type AnimateDivProps = React.ComponentProps<typeof StyledMotionDiv>;

/**
 * A simple container that's hidden based on TitleState.
 * It's animated out when showRenameForm is true and translated to the left
 */
export const AnimatedDiv = forwardRef<HTMLDivElement, AnimateDivProps>(
  ({ children, ...props }, ref) => {
    const { containerTranslation, showRenameForm } = useTitleState();

    const animationProps = {
      visible: {
        opacity: 1,
        x: 0,
        transition: {
          delay: 0.2,
          type: "spring",
          bounce: 0,
        },
      },
      hidden: {
        opacity: 0,
        x: containerTranslation / 2,
      },
    };

    return (
      <StyledMotionDiv
        ref={ref}
        animate={showRenameForm ? "hidden" : "visible"}
        {...props}
        css={{
          ...props.css,
          pointerEvents: showRenameForm ? "none" : "auto",
        }}
        variants={animationProps}
      >
        {children}
      </StyledMotionDiv>
    );
  },
);
